import React from 'react'
import Header from '../components/Header.jsx';
import Container from '@mui/material/Container';
import '../styles/Home.css'
import {FaGithub, FaMedium, FaLinkedin} from "react-icons/fa";
import profilePic from '../images/profilepic.png';


export const Home = () => {
    return (<div className="dot-background">
            <Header/>
            <Container maxWidth="md" className="home-container">
                <section className="home-hero">
                    <div className="home-hero-text">
                        <p className="home-kicker">Software Developer</p>
                        <h1 className="home-title">Hi, I am Kaan!</h1>
                        <p className="home-description">
                            I build software that is easy to use, easy to maintain, and pleasant to evolve.
                        </p>
                    </div>
                    <img className="home-avatar" src={profilePic} alt="Kaan Hakan" loading="lazy"/>
                </section>

                <section className="home-section">
                    <h2>About me</h2>
                    <p>
                        Software Engineer with 7+ years of experience building scalable, high-impact systems
                        across
                        backend, search, and AI-powered applications. Proven track record of delivering production-grade
                        solutions, including hybrid search platforms and distributed microservices serving millions of
                        users.
                        Strong focus on system design, performance, and developer experience, with hands-on ownership of
                        CI/CD, observability, and incident management.
                    </p>
                    <p>
                        Right now I live in Berlin. If you are around, feel free to reach out, we can have a coffee or
                        work together.
                    </p>
                </section>

                <section className="home-section">
                    <h2>My Skills</h2>
                    <p>
                        <strong>Languages:</strong> Go, Java, Kotlin, Python, TypeScript
                    </p>
                    <p>
                        <strong>Backend:</strong> Spring Boot, FastAPI
                    </p>
                    <p>
                        <strong>Frontend:</strong> React
                    </p>
                    <p>
                        <strong>Architectural & Design Concepts:</strong> Microservices, Databases (SQL & NoSQL), CI/CD,
                        Docker, Kubernetes, AWS, job management systems, push notifications.
                    </p>
                    <p>
                        <strong>AI & Orchestration:</strong> LangChain, LangGraph, Agentic AI
                    </p>
                    <p>
                        <strong>Cloud & DevOps:</strong> Docker, Microservices, AWS (EC2, S3, Lambda), Kubernetes
                    </p>
                    <p>
                        <strong>Database & Search:</strong> PostgreSQL, MongoDB, MySQL, OpenSearch
                    </p>
                    <p>
                        <strong>Messaging & Streaming:</strong> NATS - Event-driven architecture
                    </p>
                </section>

                <section className="home-section">
                    <h2>Contact</h2>
                    <div className="home-links">
                        <a className="home-headingw" href="https://github.com/knhakan" title='Github'><FaGithub
                            size={'20px'}/> GitHub</a>
                        <a className="home-headingw" href="https://medium.com/@kaanonsoftware" title='Medium'><FaMedium
                            size={'20px'}/> Medium</a>
                        <a className="home-headingw" href="https://linkedin.com/in/kaan-hakan/"
                           title='Linkedin'><FaLinkedin size={'20px'}/> Linkedin</a>
                    </div>
                    <p className="home-email">Or email me at knhakan@gmail.com</p>
                </section>

                <div className="home-spacer"/>
            </Container>
        </div>)
}

export default Home
